import styled from 'styled-components';

const BodyContainer = styled.div`
    max-width: ${p => p.theme.siteConfig.maxContentWidth ? p.theme.siteConfig.maxContentWidth : 990}px;
    left: 0;
    right: 0;
    margin: auto;
`

export default BodyContainer;